// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"478":"organization","943":"root"}[chunkId] || chunkId) + "." + {"478":"709ce262","654":"058f6ac4","903":"c89e7622","943":"2d1173a9"}[chunkId] + ".chunk.js";
};